import * as React from "react";
import { SVGProps } from "react";
const SvgCheckboxMixedInverted = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#checkbox-mixed-inverted_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0c3.589 0 7.277.3 10.766.998 2.094.4 3.789 2.097 4.187 4.194a56.066 56.066 0 0 1 0 21.566c-.398 2.097-2.093 3.794-4.187 4.194a55.809 55.809 0 0 1-21.532 0c-2.094-.4-3.789-2.097-4.187-4.194a56.066 56.066 0 0 1 0-21.566C1.445 3.095 3.14 1.398 5.234.998 8.723.3 12.41 0 16 0Zm8.175 15H7.825a.733.733 0 0 0-.59.286C7.08 15.476 7 15.714 7 16s.079.524.236.714c.157.19.354.286.59.286h16.349a.733.733 0 0 0 .59-.286c.156-.19.235-.428.235-.714s-.079-.524-.236-.714a.734.734 0 0 0-.59-.286h.001Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="checkbox-mixed-inverted_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckboxMixedInverted;
